(function() {
  var $85422cf03c4fea94$export$2e2bcd8739ae039 = (() => {
    if (!customElements.get("read-more")) customElements.define("read-more", class extends HTMLElement {
      constructor() {
        super();
        this.toggle = this.toggle.bind(this);
        this.checkOverflow = this.checkOverflow.bind(this);
      }
      connectedCallback() {
        this.button = this.querySelector("[data-toggle]");
        this.content = this.querySelector("[data-content]");
        this.buttonWrapper = this.button?.parentElement;
        if (!this.button || !this.content) return;
        this.readMoreText = this.getAttribute("data-read-more-text") || "Translation missing: en.general.read_more";
        this.readLessText = this.getAttribute("data-read-less-text") || "Translation missing: en.general.read_less";
        this.isExpanded = false;
        this.button.addEventListener("click", this.toggle);
        this.checkOverflow();
        this.observer = new ResizeObserver(this.checkOverflow);
        this.observer.observe(this);
      }
      disconnectedCallback() {
        if (this.button) this.button.removeEventListener("click", this.toggle);
        if (this.observer) this.observer.disconnect();
      }
      checkOverflow() {
        if (this.isExpanded) return;
        const isOverflowing = this.content.scrollHeight > this.content.clientHeight;
        if (this.buttonWrapper) this.buttonWrapper.classList.toggle("hidden", !isOverflowing); else this.button.classList.toggle("hidden", !isOverflowing);
      }
      toggle(event) {
        if (event) event.preventDefault();
        this.isExpanded = !this.isExpanded;
        this.content.classList.toggle("is-expanded", this.isExpanded);
        this.button.textContent = this.isExpanded ? this.readLessText : this.readMoreText;
        this.button.setAttribute("aria-expanded", this.isExpanded);
      }
    });
  })();
})();